import React, { forwardRef } from 'react';
import { Box, Divider, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment/moment';

const Field = ({ label, value, color }) => (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
        <Typography
            sx={{
                fontSize: '11px',
                color: '#8a8b8c',
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
            }}
        >
            {label}
        </Typography>
        <Typography
            sx={{
                fontSize: '13px',
                color: color || '#245372',
                fontWeight: 500
            }}
        >
            {value || '—'}
        </Typography>
    </Box>
);

const Section = ({ title }) => (
    <Box sx={{ gridColumn: '1 / -1' }}>
        <Typography
            sx={{
                fontSize: '11px',
                fontWeight: 700,
                color: '#245372',
                textTransform: 'uppercase',
                letterSpacing: '0.8px',
                mb: '6px'
            }}
        >
            {title}
        </Typography>
        <Divider sx={{ borderColor: '#3DC3C1', mb: '12px' }} />
    </Box>
);

const FXOrderLogDetail = forwardRef(({ handleClose, order }, ref) => {
    if (!order) return null;

    return (
        <Box className="modal-container" ref={ref} sx={{ minWidth: '600px' }}>
            <Box
                className="flex justify-between modal-header"
                sx={{ alignItems: 'center' }}
            >
                <h2 className="modal-title">FX Order Details</h2>
                <CloseIcon
                    className="cursor-pointer"
                    onClick={handleClose}
                    sx={{ color: '#245372' }}
                />
            </Box>
            <Box className="modal-body">
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: '16px'
                    }}
                >
                    <Section title="Reference" />
                    <Field label="Order ID" value={order.order_id} />
                    <Field label="Batch ID" value={order.batch_id} />
                    <Box sx={{ gridColumn: '1 / -1' }}>
                        <Field label="Order UUID" value={order.order_uuid} />
                    </Box>
                    <Section title="Contract Info" />
                    <Field
                        label="Contract"
                        value={order.contract}
                        color="#3B9D9D"
                    />
                    <Field label="Status" value={order.status} />
                    <Field label="Volume" value={order.volume} />
                    <Field label="Price" value={order.price} />
                    <Field label="Total Price" value={order.total_price} />
                    <Field label="Currency" value={order.currency} />

                    <Section title="Currency Exchange" />
                    <Field label="Buy Currency" value={order.buy_currency} />
                    <Field label="Buy Amount" value={order.buy_amount} />
                    <Field label="Sell Currency" value={order.sell_currency} />
                    <Field label="Sell Amount" value={order.sell_amount} />

                    <Section title="Rates" />
                    <Field label="Spot Rate" value={order.spot_rate} />
                    <Field label="Forward Rate" value={order.forward_rate} />
                    <Field
                        label="Forward Points"
                        value={order.forward_points}
                    />
                    <Field label="Market Rate" value={order.market_rate} />
                    <Field
                        label="Rate Inc Mgts Fee"
                        value={order.rate_inc_mgts_fee}
                    />

                    <Section title="Settlement & Counterparty" />
                    <Field label="Counterparty" value={order.counterparty} />
                    <Field
                        label="Settlement Date"
                        value={order.settlement_date}
                    />

                    <Section title="Dates" />
                    <Field
                        label="Created At"
                        value={
                            order.created_at
                                ? moment(order.created_at).format(
                                      'YYYY-MM-DD HH:mm:ss'
                                  )
                                : null
                        }
                    />
                    <Field
                        label="Updated At"
                        value={
                            order.updated_at
                                ? moment(order.updated_at).format(
                                      'YYYY-MM-DD HH:mm:ss'
                                  )
                                : null
                        }
                    />

                    <Section title="Order Details" />
                    <Field label="buyer" value={order?.order_details?.buyer} />
                    <Field
                        label="seller"
                        value={order?.order_details?.seller}
                    />
                    <Field label="Type" value={order?.order_details?.type} />
                    <Field
                        label="Delivery Point"
                        value={order?.order_details?.deliverypoint}
                    />
                    <Field
                        label="Created At"
                        value={
                            order?.order_details?.created_at
                                ? moment(order.order_details.created_at).format(
                                      'YYYY-MM-DD HH:mm:ss'
                                  )
                                : null
                        }
                    />
                    <>
                        <Field
                            label="Buyer Email"
                            value={order.order_details.buyer_email}
                        />
                        <Field
                            label="Seller Email"
                            value={order.order_details.seller_email}
                        />
                        <Field
                            label="User Full Name"
                            value={order.order_details.user_full_name}
                        />
                        <Field
                            label="User Email"
                            value={order.order_details.user_email}
                        />
                    </>
                </Box>
            </Box>
            <Box className="modal-footer">
                <button
                    className="modal-button-secondary"
                    onClick={handleClose}
                >
                    Close
                </button>
            </Box>
        </Box>
    );
});

export default FXOrderLogDetail;
